import script from "./AnexoUploadPage.vue?vue&type=script&setup=true&lang=js"
export * from "./AnexoUploadPage.vue?vue&type=script&setup=true&lang=js"

import "./AnexoUploadPage.vue?vue&type=style&index=0&id=1636bb84&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1636bb84"]])

export default __exports__